module.exports = __webpack_public_path__ + "static/media/Martina.d28632bd.jpg";